import backBtn from "../../../../images/back-btn.svg";
import { Head, Link } from "@inertiajs/react";
import { sanitizeHtml } from "@/Components/DraftEditor";
import './default-view.scss';
import PDFPreview from "@/Components/PDFPreview";

export default function DefaultView({
    title,
    details,
    is_pdf,
    pdf_url,
    guestView,
} : {
    title: string;
    details?: string;
    is_pdf?: boolean;
    pdf_url?: string;
    guestView?: boolean;
}) {

    const renderPageHeader = () => {

        return (
            <>
                <div className={`module-title title-wrapper ${guestView ? 'guest-title-wrapper' : ''}`}>
                    <div className={`back-btn-wrapper ${guestView ? 'guest-back-btn-wrapper' : ''}`}>
                        <Link
                            href={guestView ? route("login") : route("dashboard")}
                            tabIndex={-1}
                            className="primary-back-btn"
                        >
                            <img src={backBtn} alt="back-icon" className="img-fluid" />
                        </Link>
                        <h5>{title}</h5>
                    </div>
                </div>
            </>
        )
    }

    const renderPageDetails = () => {

        return (
            <>
            <div className="input-group-wrapper">
                <div className="input-field full-column">
                    {is_pdf ? (
                        <PDFPreview
                            url={pdf_url ?? ''}
                        />
                    ) : (
                        <p 
                            className="tiptap-view"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(details ?? ""),
                            }}
                        >
                        </p>
                    )}
                </div>
            </div>
            </>
        )
    }

    return (
        <>
            <Head title={title} />
            <form className={guestView ? "guest-view-only" : "view-only-field"}>
                <div className={`${guestView ? "portal-info-module" : "dashboard-panel"}`}>
                    <div className="common-box-container">
                        {renderPageHeader()}
                        {renderPageDetails()}
                    </div>
                </div>
            </form>
        </>
    );
}